export const FIRST_CAMPAIGN_AUCTION_PROMO = 'FIRST_CAMPAIGN_AUCTION_PROMO';

export const getClickmePromoDiscountedPrice = (
    price: number,
    discountPercent?: number,
    maxDiscount?: number
): number => {
    const discountAmount = discountPercent ? Math.round((price * discountPercent) / 100) : 0;
    return maxDiscount && discountAmount > maxDiscount ? price - maxDiscount : price - discountAmount;
};
